import { Navigate } from 'react-router-dom';

/** Preserves bookmarks and old sidebar links to `/enduser/hcp-profile`. */
export default function LegacyHcpProfileRedirect() {
  return <Navigate to="/enduser/profile/hcp" replace />;
}
